import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { X, Bell } from "lucide-react";

export const DispensarX = ({ chave, onDone, testid }) => {
  const fechar = async (e) => {
    e.stopPropagation();
    try { await api.post("/copilot/dispensar", { chave }); onDone(); } catch (err) { toast.error(apiError(err)); }
  };
  return (
    <button onClick={fechar} title="Fechar este alerta" data-testid={testid}
      className="absolute top-1 right-1 p-1 rounded text-slate-400 hover:text-rose-600 hover:bg-rose-50 transition-colors">
      <X size={12} />
    </button>
  );
};

export const CopilotLembretes = ({ lembretes, onDone }) => {
  if (!lembretes?.length) return null;
  return (
    <div data-testid="copilot-group-lembretes">
      <div className="text-[10px] font-semibold uppercase text-slate-400 mb-1.5 flex items-center gap-1"><Bell size={11} /> Lembretes</div>
      <div className="space-y-1">
        {lembretes.map((l) => (
          <div key={l.chave} className="relative text-xs bg-yellow-50 border border-yellow-200 rounded-md p-2 pr-7" data-testid={`copilot-lembrete-${l.chave}`}>
            {l.texto}
            <DispensarX chave={l.chave} onDone={onDone} testid={`copilot-lembrete-fechar-${l.chave}`} />
          </div>
        ))}
      </div>
    </div>
  );
};
